import { BASE_JOURNEY_ID } from '#journeys/baseJourney'

import type { QuestDoc } from './schemas'

/**
 * Which journey a quest belongs to.
 *
 * A quest written before journeys existed carries no id, and belongs to the
 * base journey — the one every user already had, under the name their plan has
 * always been. Nothing has to be migrated for that to be true.
 */
export const journeyIdOf = (quest: QuestDoc): string =>
  quest.entity.journeyId ?? BASE_JOURNEY_ID

/** The quests of one journey, which is all any screen or figure is about. */
export const questsInJourney = (
  quests: readonly QuestDoc[],
  journeyId: string
): QuestDoc[] => quests.filter(quest => journeyIdOf(quest) === journeyId)
